"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("@react-mdc/base");
var constants_1 = require("./constants");
exports.CLASS_NAME = constants_1.BASE_CLASS_NAME;
exports.propertyClassNames = {
    PREFIX: exports.CLASS_NAME,
    DENSE: exports.CLASS_NAME + "--dense",
    RAISED: exports.CLASS_NAME + "--raised",
    COMPACT: exports.CLASS_NAME + "--compact",
    PRIMARY: exports.CLASS_NAME + "--primary",
    ACCENT: exports.CLASS_NAME + "--accent",
};
var Meta = (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Meta.prototype.renderBaseClassName = function () {
        return exports.CLASS_NAME;
    };
    Meta.prototype.renderClassValues = function (_childProps) {
        return [(_a = {},
                _a[exports.propertyClassNames.DENSE] = this.props.dense,
                _a[exports.propertyClassNames.RAISED] = this.props.raised,
                _a[exports.propertyClassNames.COMPACT] = this.props.compact,
                _a[exports.propertyClassNames.PRIMARY] = this.props.primary,
                _a[exports.propertyClassNames.ACCENT] = this.props.accent,
                _a)];
        var _a;
    };
    return Meta;
}(base_1.ClassNameMetaBase));
exports.Meta = Meta;
var Button = (function (_super) {
    __extends(Button, _super);
    function Button() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Button.prototype.getMetaComponent = function () {
        return Meta;
    };
    Button.prototype.getMetaPropNames = function () {
        return [
            "dense",
            "raised",
            "compact",
            "primary",
            "accent",
        ];
    };
    Button.prototype.getChildComponent = function () {
        return "button";
    };
    Button.Meta = Meta;
    return Button;
}(base_1.DefaultComponentBase));
exports.default = Button;
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/button/lib/Button.js
// module id = ./node_modules/@react-mdc/button/lib/Button.js
// module chunks = 1